/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SmsSentDto
 */
export interface SmsSentDto {
    /**
     * 
     * @type {string}
     * @memberof SmsSentDto
     */
    result: string;
}

/**
 * Check if a given object implements the SmsSentDto interface.
 */
export function instanceOfSmsSentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function SmsSentDtoFromJSON(json: any): SmsSentDto {
    return SmsSentDtoFromJSONTyped(json, false);
}

export function SmsSentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsSentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': json['result'],
    };
}

export function SmsSentDtoToJSON(value?: SmsSentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}

